
import PartnerOffers from './PartnerOffers.vue';
import PartnerQualifications from './PartnerQualifications.vue';
import RejectedJobs from './RejectedJobs.vue';
import Accounting from './PartnerAccounting.vue';
import PartnerNotes from './PartnerNotes.vue';
import PartnerBillingTax from './PartnerBillingTax.vue';
import PartnerContacts from './PartnerContacts.vue';
import ActivityFeed from '@gid/vue-common/components/ActivityFeed.vue';
import { defineComponent } from 'vue';
import PartnerOnPause from './PartnerOnPause.vue';
import PartnerPrices from './PartnerPrices.vue';
import PartnerPriceRequests from './PartnerPriceRequests.vue';

export default defineComponent({
  components: {
    PartnerOffers,
    PartnerQualifications,
    RejectedJobs,
    Accounting,
    PartnerNotes,
    PartnerBillingTax,
    PartnerContacts,
    ActivityFeed,
    PartnerOnPause,
    PartnerPrices,
    PartnerPriceRequests,
  },
  props: {
    partner: {
      type: Object,
      required: true,
    },
    includeChildren: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async update() {
      this.$emit('update');
    },
  },
});
